import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiSadFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1M9.456 17.446c-.368.392-.556.843-.556 1.304H7.1c0-.98.407-1.858 1.044-2.536.917-.977 2.326-1.564 3.856-1.564s2.939.586 3.856 1.564c.637.678 1.044 1.556 1.044 2.536h-1.8c0-.46-.188-.912-.556-1.304-.542-.577-1.457-.996-2.544-.996-1.088 0-2.002.419-2.544.996M17.5 10.4h-4V8.6h4zm-11 0h4V8.6h-4z"
            fill="currentColor"
        />
    </svg>
));
EmojiSadFilledSize24Glyph.displayName = 'EmojiSadFilledSize24Glyph';
